import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=3ae72246&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"
import style0 from "./BankAccount.vue?vue&type=style&index=0&id=3ae72246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae72246",
  null
  
)

export default component.exports